
export const getDistributionLevelLabel = (item) => {
    return {
        "1": item?.selections?.canadaMailing ? "Canadian Lettermail Mailing" : "First Class Mailing",
        "3": item?.selections?.canadaMailing ? "Canadian Admail Mailing" : "Standard Mailing",
        "5": "Neighborhood Direct Mail"
    }[item.selections.distributionLevel];
};
